import { render, staticRenderFns } from "./FullImage.vue?vue&type=template&id=6c9dd9de&scoped=true&"
import script from "./FullImage.vue?vue&type=script&lang=js&"
export * from "./FullImage.vue?vue&type=script&lang=js&"
import style0 from "./FullImage.vue?vue&type=style&index=0&id=6c9dd9de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9dd9de",
  null
  
)

export default component.exports